export class BusyIndicatorMessage<T> {
    constructor(public identifier: T, public message: string) {
        if (identifier === null || identifier === undefined) {
            throw new Error('Busy Indicator message identifier cannot be null or undefined.');
        }
        if (message === null || message === undefined) {
            throw new Error('Busy Indicator message cannot be null or undefined.');
        }
    }
}